<template lang="pug">
  .box(:class="areaTitle ? 'box-primary' : 'box-solid'")
    .box-header.with-border(v-if="areaTitle")
      .box-title(v-html="areaTitle")
    .box-body
      //- 初期データが来るまで待機
      loading(v-if="!isModelInitialized")
      .row(v-else)
        .col-lg-6.col-lg-push-6.bcard-card-addimage
          file-droppable(
            v-if="fileDropReloader",
            v-model="value.images",
            :main-image-id="value.image_id",
            :multi="true",
            :edit_mode="isImageEdit()",
            :conf_mode="isImageConf()",
            :view_mode="isImageView()"
          )
          template(v-if="isClone")
            .checkbox.checkbox-rich.form-group
              label.form-control-static
                input(type="checkbox" v-model="useClonedImages" @change="changeClonedFlag")
                span: i.fa.fa-check.fa-lg
                | {{value.full_name}} さんの最新名刺画像を流用する

        .col-lg-6.col-lg-pull-6
          //------------------------------------------------------------
          //- 姓名
          //------------------------------------------------------------
          .row.bcard-card-add-row
            //- 姓
            .col-xs-6
              .bcard-card-add-field(:class="fieldModes['last_name']")
                .form-group(:class="{'has-warning': isFieldChanged('last_name')}",
                    @dblclick="changeFieldMode('edit', 'last_name')")
                  .clearfix
                    label(for="last_name") 姓
                      span.bcard-required (*)
                      //- p {{useCompare}}
                      //- p {{value.last_name}} | {{originalBcard.last_name}}
                  p.form-control-static(v-if="isFieldView('last_name')") {{value.last_name || app_lang.NO_INPUT}}
                  input.form-control(:type="isFieldView('last_name') ? 'hidden' : 'text'", name="last_name", id="last_name", v-model="value.last_name", @input="onChangeName($event, 'last_name', 'last_kana')", :maxlength="maxlengths.last_name", required)

            //- 名
            .col-xs-6
              .bcard-card-add-field(:class="fieldModes['first_name']")
                .form-group(:class="{'has-warning': isFieldChanged('first_name')}",
                    @dblclick="changeFieldMode('edit', 'first_name')")
                  .clearfix
                    label(for="first_name") 名
                  p.form-control-static(v-if="isFieldView('first_name')") {{value.first_name || app_lang.NO_INPUT}}
                  input.form-control(:type="isFieldView('first_name') ? 'hidden' : 'text'", name="first_name", id="first_name", v-model="value.first_name", @input="onChangeName($event, 'first_name', 'first_kana')", :maxlength="maxlengths.first_name")

          //------------------------------------------------------------
          //- 姓名（よみがな）
          //------------------------------------------------------------
          .row.bcard-card-add-row
            //- 姓（よみがな）
            .col-xs-6
              .bcard-card-add-field(:class="fieldModes['last_kana']")
                .form-group(:class="{'has-warning': isFieldChanged('last_kana')}",
                    @dblclick="changeFieldMode('edit', 'last_kana')")
                  .clearfix
                    label(for="last_kana") 姓（よみがな）
                      span.bcard-required (*)
                  p.form-control-static(v-if="isFieldView('last_kana')") {{value.last_kana || app_lang.NO_INPUT}}
                  input.form-control(:type="isFieldView('last_kana') ? 'hidden' : 'text'", name="last_kana", id="last_kana", v-model="value.last_kana", :maxlength="maxlengths.last_kana", required)

            //- 名（よみがな）
            .col-xs-6
              .bcard-card-add-field(:class="fieldModes['first_kana']")
                .form-group(:class="{'has-warning': isFieldChanged('first_kana')}",
                    @dblclick="changeFieldMode('edit', 'first_kana')")
                  .clearfix
                    label(for="first_kana") 名（よみがな）
                  p.form-control-static(v-if="isFieldView('first_kana')") {{value.first_kana || app_lang.NO_INPUT}}
                  input.form-control(:type="isFieldView('first_kana') ? 'hidden' : 'text'", name="first_kana", id="first_kana", v-model="value.first_kana", :maxlength="maxlengths.first_kana")

          //------------------------------------------------------------
          //- 会社
          //------------------------------------------------------------
          .bcard-card-add-field(:class="fieldModes['corporate_name']")
            .form-group(:class="{'has-warning': isFieldChanged('corporate_name')}",
                @dblclick="changeFieldMode('edit', 'corporate_name')")
              .clearfix
                label(for="corporate_name") 会社名
              p.form-control-static(v-if="isFieldView('corporate_name')") {{value.corporate_name || app_lang.NO_INPUT}}
              input.form-control(:type="isFieldView('corporate_name') ? 'hidden' : 'text'", name="corporate_name", id="corporate_name", v-model="value.corporate_name", :maxlength="maxlengths.corporate_name")

          //------------------------------------------------------------
          //- 会社名（よみがな）
          //------------------------------------------------------------
          .bcard-card-add-field(:class="fieldModes['corporate_kana']")
            .form-group(:class="{'has-warning': isFieldChanged('corporate_kana')}",
                @dblclick="changeFieldMode('edit', 'corporate_kana')")
              .clearfix
                label(for="corporate_kana") 会社名（よみがな）
              p.form-control-static(v-if="isFieldView('corporate_kana')") {{value.corporate_kana || app_lang.NO_INPUT}}
              input.form-control(:type="isFieldView('corporate_kana') ? 'hidden' : 'text'", name="corporate_kana", id="corporate_kana", v-model="value.corporate_kana", :maxlength="maxlengths.corporate_kana")
              .help-block
                p.bcard-comments.text-info ※ 法人格を除いて入力してください。

          //------------------------------------------------------------
          //- 部署
          //------------------------------------------------------------
          .bcard-card-add-field(:class="fieldModes['dept']")
            //- .form-group(:class="{'has-warning': isFieldChanged('dept')}",
            .form-group(:class="{'has-warning': isFieldChanged('dept')}",
                @dblclick="changeFieldMode('edit', 'dept')")
              .clearfix
                label(for="dept") 部署名
              p.form-control-static(v-if="isFieldView('dept')") {{value.dept || app_lang.NO_INPUT}}
              input.form-control(:type="isFieldView('dept') ? 'hidden' : 'text'", name="dept", id="dept", v-model="value.dept", :maxlength="maxlengths.dept")

          //------------------------------------------------------------
          //- 役職
          //------------------------------------------------------------
          .bcard-card-add-field(:class="fieldModes['post']")
            .form-group(:class="{'has-warning': isFieldChanged('post')}",
                @dblclick="changeFieldMode('edit', 'post')")
              .clearfix
                label(for="post") 役職
              p.form-control-static(v-if="isFieldView('post')") {{value.post || app_lang.NO_INPUT}}
              input.form-control(:type="isFieldView('post') ? 'hidden' : 'text'", name="post", id="post", v-model="value.post", :maxlength="maxlengths.post")

          //------------------------------------------------------------
          //- 住所
          //------------------------------------------------------------
          .bcard-card-add-field(:class="fieldModes['zipcode']")
            .form-group(:class="{'has-warning': isFieldChanged(['zipcode', 'address1', 'address2'])}",
                @dblclick="changeFieldMode('edit', ['zipcode', 'address1', 'address2'])")
              .clearfix
                label(for="zipcode") 住所
              .form-inline
                .input-group
                  .input-group-addon(v-if="!isFieldView('zipcode')") 〒
                  p.form-control-static(v-if="isFieldView('zipcode')") 〒 {{value.zipcode || app_lang.NO_INPUT}}
                  input.form-control(:type="isFieldView('zipcode') ? 'hidden' : 'text'", name="zipcode", id="zipcode", v-model="value.zipcode", :maxlength="maxlengths.zipcode", @input="setAddress(value.zipcode, 'address1')")
              p.form-control-static(v-if="isFieldView('address1')") {{value.address1 || app_lang.NO_INPUT}}
              input.form-control(:type="isFieldView('address1') ? 'hidden' : 'text'", name="address1", id="address1", v-model="value.address1", :maxlength="maxlengths.address1")
              p.form-control-static(v-if="isFieldView('address2')") {{value.address2 || app_lang.NO_INPUT}}
              input.form-control(:type="isFieldView('address2') ? 'hidden' : 'text'", name="address2", id="address2", v-model="value.address2", :maxlength="maxlengths.address2")

          //------------------------------------------------------------
          //- 会社電話
          //------------------------------------------------------------
          .bcard-card-add-field(:class="fieldModes['corporate_tel']")
            .form-group(:class="{'has-warning': isFieldChanged('corporate_tel')}",
                @dblclick="changeFieldMode('edit', 'corporate_tel')")
              .clearfix
                label(for="corporate_tel") 会社電話
              p.form-control-static(v-if="isFieldView('corporate_tel')") {{value.corporate_tel || app_lang.NO_INPUT}}
              input.form-control(:type="isFieldView('corporate_tel') ? 'hidden' : 'text'", name="corporate_tel", id="corporate_tel", v-model="value.corporate_tel", :maxlength="maxlengths.corporate_tel")

          //------------------------------------------------------------
          //- 部署電話
          //------------------------------------------------------------
          .bcard-card-add-field(:class="fieldModes['dept_tel']")
            .form-group(:class="{'has-warning': isFieldChanged('dept_tel')}",
                @dblclick="changeFieldMode('edit', 'dept_tel')")
              .clearfix
                label(for="dept_tel") 部署電話
              p.form-control-static(v-if="isFieldView('dept_tel')") {{value.dept_tel || app_lang.NO_INPUT}}
              input.form-control(:type="isFieldView('dept_tel') ? 'hidden' : 'text'", name="dept_tel", id="dept_tel", v-model="value.dept_tel", :maxlength="maxlengths.dept_tel")

          //------------------------------------------------------------
          //- 内線
          //------------------------------------------------------------
          .bcard-card-add-field(:class="fieldModes['naisen']")
            .form-group(:class="{'has-warning': isFieldChanged('naisen')}",
                @dblclick="changeFieldMode('edit', 'naisen')")
              .clearfix
                label(for="naisen") 内線
              p.form-control-static(v-if="isFieldView('naisen')") {{value.naisen || app_lang.NO_INPUT}}
              input.form-control(:type="isFieldView('naisen') ? 'hidden' : 'text'", name="naisen", id="naisen", v-model="value.naisen", :maxlength="maxlengths.naisen")

          //------------------------------------------------------------
          //- 携帯電話
          //------------------------------------------------------------
          .bcard-card-add-field(:class="fieldModes['hand_tel']")
            .form-group(:class="{'has-warning': isFieldChanged('hand_tel')}",
                @dblclick="changeFieldMode('edit', 'hand_tel')")
              .clearfix
                label(for="hand_tel") 携帯電話
              p.form-control-static(v-if="isFieldView('hand_tel')") {{value.hand_tel || app_lang.NO_INPUT}}
              input.form-control(:type="isFieldView('hand_tel') ? 'hidden' : 'text'", name="hand_tel", id="hand_tel", v-model="value.hand_tel", :maxlength="maxlengths.hand_tel")

          //------------------------------------------------------------
          //- FAX
          //------------------------------------------------------------
          .bcard-card-add-field(:class="fieldModes['fax']")
            .form-group(:class="{'has-warning': isFieldChanged('fax')}",
                @dblclick="changeFieldMode('edit', 'fax')")
              .clearfix
                label(for="fax") FAX
              p.form-control-static(v-if="isFieldView('fax')") {{value.fax || app_lang.NO_INPUT}}
              input.form-control(:type="isFieldView('fax') ? 'hidden' : 'text'", name="fax", id="fax", v-model="value.fax", :maxlength="maxlengths.fax")

          //------------------------------------------------------------
          //- メールアドレス
          //------------------------------------------------------------
          .bcard-card-add-field(:class="fieldModes['mail']")
            .form-group(:class="{'has-warning': isFieldChanged('mail')}",
                @dblclick="changeFieldMode('edit', 'mail')")
              .clearfix
                label(for="mail") メールアドレス
              p.form-control-static(v-if="isFieldView('mail')") {{value.mail || app_lang.NO_INPUT}}
              input.form-control(:type="isFieldView('mail') ? 'hidden' : 'text'", name="mail", id="mail", v-model="value.mail", :maxlength="maxlengths.mail")

          //------------------------------------------------------------
          //- URL
          //------------------------------------------------------------
          .bcard-card-add-field(:class="fieldModes['url']")
            .form-group(:class="{'has-warning': isFieldChanged('url')}",
                @dblclick="changeFieldMode('edit', 'url')")
              .clearfix
                label(for="url") URL
              p.form-control-static(v-if="isFieldView('url')") {{value.url || app_lang.NO_INPUT}}
              input.form-control(:type="isFieldView('url') ? 'hidden' : 'text'", name="url", id="url", v-model="value.url", :maxlength="maxlengths.url")

          .help-block
            p.bcard-required ※ (*)は必須項目です。

</template>

<script>
import FileDroppable from '@/components/organisms/FileDroppable'
import Loading from '@/components/molecules/Loading'
import mixinForm from '@/mixins/form'
import mixinAddbcard from '@/mixins/addbcard'

export default {
  name: 'EditUserData',
  components: { FileDroppable, Loading },
  mixins: [ mixinForm, mixinAddbcard ],
  data: function () {
    return {
      // 名刺情報フィールドの入力モード
      // edit: 編集画面で入力欄を表示する
      // conf: 編集画面で入力値を表示する
      // null: 編集画面はeditと同じ、確認画面はconfと同じ
      fieldModes: {
        // プロパティまでreactiveにするために最初にdefineしておく
        last_name: null,
        first_name: null,
        last_kana: null,
        first_kana: null,
        // full_name: null,
        corporate_name: null,
        corporate_kana: null,
        dept: null,
        post: null,
        mail: null,
        zipcode: null,
        address1: null,
        address2: null,
        corporate_tel: null,
        dept_tel: null,
        naisen: null,
        hand_tel: null,
        fax: null,
        url: null,
        images: []
      },
      maxlengths: {}
    }
  },
  created () {
    this.maxlengths = this.loadMaxlengths('Users')
  }
}
</script>

<style lang="scss" scoped>
@import '~bootstrap-sass/assets/stylesheets/bootstrap/variables';
.bcard-card-add-row {
  padding: 5px;
  margin: -5px -10px;
  > .col-xs-6 {
    padding-left: 5px;
    padding-right: 5px;
  }
}

// 名刺情報入力フィールド
.bcard-card-add-field {
  padding: 5px;
  margin: -5px;
  &:not(.edit) {
    .input-group-addon {
      border-color: transparent;
      background-color: transparent;
    }
  }

  &.conf:hover {
    background-color: $list-group-hover-bg;
  }

  /* 流用入力 */
  .form-group.has-warning {
    background-color: $state-warning-bg;
  }
  /* 部署などの余白調整 */
  // .bcard-card-add-field .form-group:first-child + .form-group {
  //   margin-top: -$form-group-margin-bottom;
  // }
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/UserForm.vue